import {CARD_READER_ADD, CARD_READER_DELETE, CARD_READER_ERROR} from '../actions/cardReader';

function cardReader(state = {}, action) {
  switch (action.type) {
    case CARD_READER_ADD:
      return { addID: action.id, error: '' };

    case CARD_READER_DELETE:
      return { deleteID: action.id, error: '' };

    case CARD_READER_ERROR:
      return { error: action.error };
  }
  return state;
}

export default cardReader;



// WEBPACK FOOTER //
// ./web/js/stores/reducers/cardReader.js